import React, { Component } from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import ScheduleByDayButtons from "./schedule-by-day-buttons";
import ScheduleByDaySchedule from "./schedule-by-day-schedule";
import moment from "moment";
import util from "../util/util";

export default class ScheduleByDay extends Component {
  constructor(props) {
    super(props);

    this.state = this.returnInitialState(props);
  }

  componentDidMount() {
    this.mounted = true;

    this.getScheduleByDay();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.returnInitialState(nextProps), this.getScheduleByDay);
  }

  render() {
    return (
      <div className="schedule-by-day">
        <div className="row">
          <div className="col-sm-4 col-sm-push-8">
            <p className="page__actions page__actions--stacked">
              <Link
                className="btn btn-default"
                to={util.returnScheduleWeekUrl(this.state.day)}
              >
                <i className="fa fa-arrow-up" aria-hidden="true"></i>
                Return to weekly schedule
              </Link>
            </p>
          </div>
          <div className="col-sm-8 col-sm-pull-4">
            <h4 className="page__title">Daily Schedule</h4>
          </div>
        </div>

        <hr />

        <ScheduleByDayButtons day={this.state.day} loaded={this.state.loaded} />

        <hr />

        <ScheduleByDaySchedule
          day={this.state.day}
          schedule={this.state.schedule}
        />
      </div>
    );
  }

  // use the same logic to set state (on load, on prop change);
  returnInitialState(props = {}) {
    return {
      day: this.returnFormattedDay(
        (props.params && props.params.day) || new Date()
      ), // the day everything is based on;
      loaded: false, // indicates that the content is ready for display (even when schedule is empty);
      schedule: this.returnEmptySchedule() // main content to display;
    };
  }

  // convert the date into a readable format;
  returnFormattedDay(date) {
    return moment(date).format(util.dateFormatComputer);
  }

  // returns an empty schedule we can now use;
  // insert Ajax content into it, or display as-is (on prop change);
  returnEmptySchedule() {
    const schedule = [];

    // loop through the 24 hours of the day;
    for (let hour = 0; hour <= 23; hour = hour + 1) {
      const hourFormatted = hour < 10 ? `0${hour}` : hour;

      // loop through the hour and half hour slot;
      // the 28 and 58 are FPO for the associated pods;
      [`00`, `28`, `30`, `58`].forEach(time => {
        // create the `table row` for each time slot;
        schedule.push({
          timeslot: `${hourFormatted}:${time}`,
          show: ``
        });
      });
    }

    return schedule;
  }

  // get the schedule data to display (one day at a time);
  getScheduleByDay() {
    const schedule = this.state.schedule;
    const processData = data => {
      data.forEach(show => {
        const airtime = moment(show.airtime);
        const timeslot = airtime.format(`HH:mm`);

        // find the timeslot (if it exists);
        schedule.forEach((slot, i) => {
          if (slot.timeslot === timeslot) {
            // add the show or interstitial to the timeslot;
            schedule[i].show = show.title
              ? show.title
              : { pod: show.pod, rule: show.rule };
          }
        });
      });
    };

    // get this days data;
    util
      .getScheduleByDay(this.state.day)
      .then(data => {
        processData(data);

        // then this weeks interstitial data;
        return util.getInterstitialsByDay(this.state.day);
      })
      .then(data => {
        processData(data);

        setTimeout(() => {
          this.mounted &&
            this.setState({
              loaded: true,
              schedule: schedule
            });
        }, util.delayList);
      });
  }
}

ScheduleByDay.propTypes = {
  params: PropTypes.object
};
